import { render, staticRenderFns } from "./uploadFileWrap.vue?vue&type=template&id=4c1f7f01&scoped=true&"
import script from "./uploadFileWrap.vue?vue&type=script&lang=js&"
export * from "./uploadFileWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1f7f01",
  null
  
)

export default component.exports